import { NgModule, Inject, Optional, SkipSelf, ɵɵdefineInjectable, ɵɵinject, Injectable } from '@angular/core';
import { DefaultGlobalConfig, TOAST_CONFIG, ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from 'ngx-toastr';
function toasterConfigFactory(config) {
    return config || {
        default: DefaultGlobalConfig,
        config: {},
    };
}
class ToasterModule {
}
ToasterModule.ɵfac = function ToasterModule_Factory(t) { return new (t || ToasterModule)(); };
ToasterModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ToasterModule });
ToasterModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        {
            provide: TOAST_CONFIG,
            useFactory: toasterConfigFactory,
            deps: [[new Inject(TOAST_CONFIG), new Optional(), new SkipSelf()]]
        }
    ] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToasterModule, [{
        type: NgModule,
        args: [{
                providers: [
                    {
                        provide: TOAST_CONFIG,
                        useFactory: toasterConfigFactory,
                        deps: [[new Inject(TOAST_CONFIG), new Optional(), new SkipSelf()]]
                    }
                ]
            }]
    }], null, null); })();

class ToasterService {
    constructor(http, toastr, environment) {
        this.http = http;
        this.toastr = toastr;
        this.environment = environment;
        this.settings = {
            timeOut: 2000,
            progressAnimation: 'decreasing',
            progressBar: true,
            positionClass: 'toast-bottom-right',
        };
    }
    successToast(message, timeOut) {
        setTimeout(() => this.toastr.success(message.content, message.title, {
            timeOut: timeOut ? timeOut : this.settings.timeOut,
            progressBar: this.settings.progressBar,
            positionClass: this.settings.positionClass,
        }));
    }
    errorToast(message, timeOut) {
        setTimeout(() => this.toastr.error(message.content, message.title, {
            timeOut: timeOut ? timeOut : this.settings.timeOut,
            progressBar: this.settings.progressBar,
            positionClass: this.settings.positionClass,
        }));
    }
    warningToast(message, timeOut) {
        setTimeout(() => this.toastr.warning(message.content, message.title, {
            timeOut: timeOut || this.settings.timeOut,
            progressBar: this.settings.progressBar,
            positionClass: this.settings.positionClass,
        }));
    }
    infoToast(message) {
        setTimeout(() => this.toastr.info(message.content, message.title, {
            timeOut: this.settings.timeOut,
            progressBar: this.settings.progressBar,
            positionClass: this.settings.positionClass,
        }));
    }
    sendReport(error) {
        if (this.environment.adminApiURL) {
            const api = `${this.environment.adminApiURL}/error-report`;
            return this.http.post(api, error);
        }
    }
}
ToasterService.ɵfac = function ToasterService_Factory(t) { return new (t || ToasterService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ɵngcc2.ToastrService), ɵngcc0.ɵɵinject('environment')); };
ToasterService.ɵprov = ɵɵdefineInjectable({ factory: function ToasterService_Factory() { return new ToasterService(ɵɵinject(HttpClient), ɵɵinject(ToastrService), ɵɵinject("environment")); }, token: ToasterService, providedIn: "root" });
ToasterService.ctorParameters = () => [
    { type: HttpClient },
    { type: ToastrService },
    { type: undefined, decorators: [{ type: Inject, args: ['environment',] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToasterService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ɵngcc2.ToastrService }, { type: undefined, decorators: [{
                type: Inject,
                args: ['environment']
            }] }]; }, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { ToasterModule, ToasterService, toasterConfigFactory };

